import { useTranslation } from 'react-i18next';

import FullNameData from './FullNameData';
import AddressData from './AddressData';
import ContactData from './ContactData';
import CopyAddress from './CopyAddress';
import { CollapseContainer } from '../../../../../components';

const ShippingAddressSection = ({shippingAddress, countyOptions, onShippingAddressChange = (updatedShippingAddress)=>{}, isEditDisabled = false, isHidden = false, editRestrictionTitle = null, editRestrictionMessage = null}) => {
    const { i18n } = useTranslation();

    if(isHidden) {
        return <></>
    }

    return (
        <section>
            <CollapseContainer
                defaultCollapsed={true}
                containerStyles={editRestrictionMessage ? "bg-yellow-100 rounded-lg p-4" : undefined}
                headerComponent={
                    <div className="flex items-center gap-3">
                        <h2 className="mb-0 text-2xl font-bold">{i18n.t('generate_shipment.shipping_address.order_details')}</h2>
                        {(editRestrictionTitle || editRestrictionMessage) && (
                            <>
                                <span className="text-yellow-800 text-2xl font-light">|</span>
                                <div className="flex flex-col">
                                    {editRestrictionTitle && <span className="text-sm font-semibold text-yellow-800">{editRestrictionTitle}</span>}
                                    {editRestrictionMessage && <span className="text-sm text-yellow-800">{editRestrictionMessage}</span>}
                                </div>
                            </>
                        )}
                    </div>
                }
                onCollapsedText={i18n.t('generate_shipment.shipping_address.see_details')}
                onNotCollapsedText={i18n.t('generate_shipment.shipping_address.hide_details')}
            >
                <div className='pt-4 flex flex-col gap-4'>
                    <FullNameData
                        shippingAddress={shippingAddress}
                        onShippingAddressChange={onShippingAddressChange}
                        isEditDisabled={isEditDisabled}
                    />

                    <ContactData
                        shippingAddress={shippingAddress}
                        onShippingAddressChange={onShippingAddressChange}
                        isEditDisabled={isEditDisabled}
                    />

                    <AddressData
                        shippingAddress={shippingAddress}
                        onShippingAddressChange={onShippingAddressChange}
                        isEditDisabled={isEditDisabled}
                        countyOptions={countyOptions}
                    />

                    <CopyAddress
                        shippingAddress={shippingAddress}
                    />
                </div>
            </CollapseContainer>
        </section>
    )
}

export default ShippingAddressSection
